module.exports = __webpack_public_path__ + "img/github.938a45e0.svg";